export class Constants {
    // Status
    static IN_PROGRESS = "InProgress";
    static NEW_STATUS = "New";
    static PROCESSED_STATUS = "Processed";
    static EXPORTED_STATUS = "Exported";

    static DEFAULT_TAKE = 20;
    static DEFAULT_SKIP = 0;
    static NO_RESULT_FOUND = "No result found"
    static ACTIVE = "active";
    static USER_ID = "userId";
    static ISSUE_NOTES = "issueNotes";

    //Employee status
    static OBJECT = "object";
    static SEARCH_PLACEHOLDER = "Search";

    //Timecard
    static PLEASE_SELECT_SOME_TIMECARDS = "Please add timecards and submit.";
    static SUBMIT_SUCCESSFULLY = "Submit complete.";

    //Division
    static ADMIN_ROLE_NAME = 'Administrator';
    static SYSTEM_ADMIN_ROLE_NAME = 'SystemAdmin';

    //Issue note
    static PLEASE_SELECT_PROJECT = "Please select project.";
    static LOST_HOURS_SHOULD_NOT_EXCEED = "Lost hours should not exceed 24.";
    static NO_ISSUE_NOTES_FOUND = "No issue notes found!";

    //Date Format
    static DDMMYYYY_FORMAT = 'DD-MM-YYYY';
    static MMDDYYYY_SLASH_FORMAT = 'MM/DD/YYYY';

    //#region Alert message types
    static SUCCESS = "success";
    static INFO = "info";
    static WARNING = "warning";
    static WARN = "warn";
    static LOADING = "loading";
    static ERROR = "error";

    static DATA_BASE64 = "data:image/png;base64,";

    static PAGE_CLAIMS = {
        SECURITY_PAGE: "pg.scrty",
        PROJECT_PAGE: "pg.prjt",
        EMPLOYEE_PAGE: "pg.emp",
        TIMECARD_PAGE: "pg.tmecrd",
        DEVICE_PAGE: "pg.dvce",
        REPORT_PAGE: "pg.rprt",
        DIVISION_PAGE: "pg.dvs",
        FORECAST_PAGE: "pg.fore"
    };

    static MENU_CLAIMS = {
        SECURITY_MENU: "mn.scrty",
        PROJECT_MENU: "mn.prjt",
        EMPLOYEE_MENU: "mn.emp",
        TIMECARD_MENU: "mn.tmecrd",
        DEVICE_MENU: "mn.dvce",
        REPORT_MENU: "mn.rprt",
        DIVISION_MENU: "mn.dvs",
        FORECAST_MENU: "mn.fore"
    }

    static BUTTON_CLAIMS = {
        PROJECT_EDIT_BUTTON: "prjtedtbtn",
        EMPLOYEE_EDIT_BUTTON: "empedtbtn",
        DEVICE_EDIT_BUTTON: "dvcedtbtn",
        REPORT_ADD_BUTTON: "addrptbtn",
        REPORT_EDIT_BUTTON: "rptedtbtn",
        REPORT_DELETE_BUTTON: "rptdltbtn",
        PROJECT_STATUS_EDIT_BUTTON: "prjtstasedtbtn",
        EMPLOYEE_STATUS_EDIT_BUTTON: "empstasedtbtn",
        DEVICE_STATUS_EDIT_BUTTON: "dvsstasedtbtn",
        EMPLOYEE_ADD_BUTTON: "addempbtn"
    }

    static AUTHORIZATION = 'Authorization';
    static BEARER = 'Bearer';
    static SPACE = " ";

    //Group Access
    static READ_ONLY = "ReadOnly";
    static CONTRIBUTE = "Contribute";
    static SYSTEM_ADMIN = "SystemAdmin";

    //Email Validation
    static PLEASE_ENTER_VALID_EMAIL = "Please enter valid email";
    static ENTER_EMAIL_ALREADY_SELECTED = "Entered email already selected";

    static ROSENDINTIME_USER = "RosendinTime";

    static DATE = "Date";
    static EMPLOYEE = "Employee";
    static PROJECT = "Project";
    static PLEASE_ENTER_PAYROLL_NOTES = "Please select any one of the payroll notes from the list.";
    static PAYROLL_NOTES_MANDATORY = "Notes are mandatory fields if you select the payroll type as Other.";

    static PROJECT_DROPDOWN = "ProjectDropDown";
    static WORKDONE_CHECKBOX = "WorkdoneDropDown";
    static SHIFT_DROPDOWN = "ShiftDropDown";
    static STATUSCODE_DROPDOWN = "StatusCodeDropDown";
    static ST_HOURS = "STHours";
    static OT_HOURS = "OTHours";
    static DT_HOURS = "DTHours";

    static DAY = "Day";
    static EVENING = "Evening";
    static NIGHT = "Night";

    static ST = "ST";
    static ST2 = "ST2";
    static ST3 = "ST3";
    static OT = "OT";
    static OT2 = "OT2";
    static OT3 = "OT3";
    static DT = "DT";

    static PAYROLL_NOTES = "PayRollNotes";
    static ACTUAL_UNITS = "ActualUnits";
    static ACTUAL_NOTES = "ActualNotes";

    static EXPECTATIONAL_UNITS = "ExpectationsUnits";
    static EXPECTATIONAL_NOTES = "ExpectationsNotes";

    static UNION_OVERRIDE = "Union Override";
    static JOB_OVERRIDE = "Job Override";

    static MAXLENGTH_REACHED = "Maxlength Reached";
    static PLEASE_SELECT_SOME_RECORDS_TO_DELETE = "Please select some records to delete.";
    static DELETED_SUCCESSFULLY = "Deleted successfully";

    static TIMECARD_PLEASE_SELECT_PROJECT = "Please select project.";
    static SELECT_EMPLOYEE = "Please select employees.";
    static START_HOUR = "StartHour";
    static START_MINUTES = "StartMinute";
    static END_HOUR = "EndHour";
    static END_MINUTES = "EndMinute";
    static LUNCH_START_HOUR = "LunchStartHour";
    static LUNCH_START_MINUTES = "LunchStartMinute";
    static LUNCH_END_HOUR = "LunchEndHour";
    static LUNCH_END_MINUTES = "LunchEndMinute";

    static ENTER_FAVORITES_GROUP_NAME = "Enter name";
    static SELECT_ONE_OR_MORE_TO_GROUP = "Select one or more {0} to form a favorites";
    static PLEASE_ENTER_PAYROLL_FOR_EMPLOYEE_WITH_ZERO_HOURS = "Please enter a payroll note for employee with '0' hours.";
    static SELECT_VALID_PROJECT = "Select valid project";
    static SELECT_VALID_TASK_CODE = "Select valid task code";
    static SELECT_VALID_SHIFT = "Select valid shift";
    static TIMECARD_IS_DUPLICATE = "Timecard is duplicate";
    static PLEASE_CHOOSE_WORK_DONE = "Please choose work done at jobsite.";
    static ST_HOURS_CANNOT_BE_GREATER = "Please check the time cards as there are ST hours greater than 10.";
    static PLEASE_ENTER_HOURS = "Please enter hours.";
    static ENTERED_HOURS_SHOULD_NOT_EXCEED = "Entered hours should not exceed 10";
    static CONFIRMATION = "Confirmation";
    static CONFIRMATION_POPUP_MESSAGE = "Do you want to save changes?";
    static PLEASE_SELECT_VALID_DEVICE_FROM_LIST = "Please select a valid device from the list.";
    static NO_TASKS_FOUND = "No tasks found";
    static WEATHER_FIELD = "weatherField";
    static SUBS_OR_VISITORS = "subOrVisitorsField";
    static INSPECTION_DESCRIPTION = "inspectionField";
    static INITIAL_FIELD = "initialField";
    static EQUIPMENT_DROPDOWN = "equipmentDropdown";
    static OTHER = "Other";
    static EQUIPMENT_DESCRIPTION = "equipmentDescription";
    static IDLE_HOURS = "idleHours";
    static PRODUCTIVE_HOURS = "productiveHours";
    static IDLE_HOURS_SHOULD_NOT_EXCEED = "Idle hours should not exceed 24.";
    static PRODUCTIVE_HOURS_SHOULD_NOT_EXCEED = "Productive hours should not exceed 24.";
    static FAILED_TO_FETCH = "Failed to fetch";
    static PLEASE_CHECK_INTERNET_CONNECTION = "Please check your internet connection.";

    static CREATE_FAVORITES = "Create Favorites";
    static HEADING_FAVORITE_EMPLOYEE_GROUPS = "Favorite Employee Groups";
    static HEADING_FAVORITE_TASK_CODE_GROUPS = "Favorite Task Code Groups";
    static DELETE_FAVORITES = "Delete Favorites";
    static PLACEHOLDER_ENTER_FAVORITES_NAME = "Enter Name";
    static CONFIRMATION_DELETED_MESSAGE = "Are you sure? Do you want to delete the selected favorites?";
    static CONFIRMATION_TASK_DELETED_MESSAGE = "Are you sure? Do you want to delete this favorites?";
    static DELETE_EQUIPMENT_HEADER = "Delete Equipment";
    static DELETE_MATERIAL_HEADER = "Delete Material";
    static DELETE_EQUIPMENT_MESSAGE = "Are you sure? Do you want to delete equipment?";
    static DELETE_MATERIAL_MESSAGE = "Are you sure? Do you want to delete material?";
    static TM_EQUIPMENT = "tmEquipments";
    static CANCEL_BUTTON = "Cancel";
    static DELETE_BUTTON = "Delete";

    //hoursRegex 
    static HOURS_REGEX = /^[0-9]*\.?[0-9]*$/;
    static UNIT_AND_QTY_REGEX = /^[0-9]+(\.[0-9]{0,2})?$/;
    static TM_VOUCHER_BUTTON_TEXT = "T&M Voucher";
    static TM_VOUCHER_REPORT_TITLE = "T&M Voucher";
    static DESCRIPTION_OF_WORK = "DescriptionOfWork";
    static APPROVED_BY = "ApprovedBy";

    static EQUIPMENT_UNIT = "EquipmentUnit";
    static EQUIPMENT_HOURS = "EquipmentHours";
    static EQUIPMENT_DAYS = "EquipmentDays";

    static MATERIAL_SIZE = "MaterialSize";
    static MATERIAL_QUANTITY = "MaterialQuantity";
    static MATERIAL_DESCRIPTION = "MaterialDescription";
    static MATERIAL_DROPDOWN = "MaterialDropdown";

    static MANUAL_SUBMITTED_MODE = "Manual";

    static PLEASE_SELECT_TASK_CODE = "Please select task code";
    static SELECT_BUTTON_TEXT = "Select";
    static BUTTON_BACK = "Back";
    static TM_VOUCHER_POPUP_HEADING_ONE = "T&M Codes Used";
    static TM_VOUCHER_POPUP_HEADING_FILL_DATA = "Select a code to Fill in T&M voucher";
    static TM_VOUCHER_POPUP_HEADING_VIEW_DATA = "Select a Code to View the T&M voucher";
    static TM_VOUCHER_DATA_ENTRY_HEADER = "Please fill in the following for T&M code";
    static TM_VOUCHER_POPUP_CONFIRMATION_MESSAGE = "Do you want to close the T&M voucher?";
    static TM_VOUCHER_DESCRIPTION_WORK_HEADER = "Description of Work";
    static TM_VOUCHER_SUBMIT = "Submit";
    static TM_VOUCHER_SUBMIT_AND_EMAIL = "Submit and Email";
    static TM_VOUCHER_SAVE = "Save";
    static TM_VOUCHER_TAB_HEADER = "T&M Voucher Data Entry";
    static PDFDATA_BASE64 = "data:application/pdf;base64,";
    static TM_VOUCHER_SUBMIT_CONFIRMATION = "No changes made. Do you still want to submit the T&M voucher?";
    static CAMERA_PERMISSION_DENIED = "Permission denied - It looks like you have turned off permission required for this feature.Allow camera and photo access permission for 'Rosendin Time' app.Permission denied - It looks like you have turned off permission required for this feature.Allow camera and photo access permission for 'Rosendin Time' app.";
    static TM_VOUCHER_SUBJECT_TEXT = "EmailSubject";
    static TM_VOUCHER_BODY_TEXT = "EmailBody";
    static TM_VOUCHER_SEND_TEXT = "sendToEmailAddress";
    static TM_VOUCHER_CC_TEXT = "ccEmailAddress";
    static TM_VOUCHER_SEND_LIST = "sendToEmailAddressList";
    static TM_VOUCHER_CC_LIST = "ccEmailAddressList";
    static TM_VOUCHER_REPORT_MODAL_HEADER = "Send Email";
    static CL_RE_TM_TAGS  = "Close and Review T&M Tags";

    static INVALID_START_TIME = "Invalid start time!";
    static INVALID_END_TIME = "Invalid end time!";
    static INVALID_LUNCH_START_TIME = "Invalid lunch start time!";
    static INVALID_LUNCH_END_TIME = "Invalid lunch end time!";
    static PLEASE_ENTER_VALID_HOURS = "Please enter valid hour.";
    static PLEASE_ENTER_VALID_MINUTES = "Please enter valid minutes.";
    static SAME_TIME_VALIDATION = "Start time and end time are same!";
    static LUNCH_SAME_TIME_VALIDATION = "Lunch start time and lunch end time are same!";
    static START_AND_LUNCH_START_TIME_VALIDATION = "Start time and lunch start time are same!";
    static END_AND_LUNCH_START_TIME_VALIDATION = "End time and lunch start time are same!";
    static START_AND_LUNCH_END_TIME_VALIDATION = "Start time and lunch end time are same!";
    static END_AND_LUNCH_END_TIME_VALIDATION = "End time and lunch end time are same!";
    static ENTER_LUNCH_START_TIME = "Please enter lunch start time.";
    static ENTER_LUNCH_END_TIME = "Please enter lunch end time.";
    static PLEASE_ENTER_NA = "Please select N/A in the punches.";
    static ENTER_LUNCH_START_TIME_AND_LUNCH_END_TIME = "Please enter lunch start and end time.";
    static REQUIRE_ALL_PUNCHES = "Please enter required punches.";
    static ENTER_START_TIME_AND_END_TIME = "Please enter start and end time.";

    static START_TIME = "StartTime";
    static END_TIME = "EndTime";
    static LUNCH_START_TIME = "LunchStartTime";
    static LUNCH_END_TIME = "LunchEndTime";

    static START_TIME_TEXT = "Start Time";
    static END_TIME_TEXT = "End Time";
    static LUNCH_START_TIME_TEXT = "Lunch Start";
    static LUNCH_END_TIME_TEXT = "Lunch End";

    static ATTESTATION_START_TIME_TEXT = "Start";
    static ATTESTATION_END_TIME_TEXT = "End";
    static ATTESTATION_LUNCH_START_TIME_TEXT = "Lunch Start";
    static ATTESTATION_LUNCH_END_TIME_TEXT = "Lunch End";

    static APPROVED_ATTESTATION_TEXT = "I certify that I have carefully reviewed my timecard and it accurately reflects all of the hours that I worked today. I further certify that I was given the opportunity to take all meal and rest breaks (if rest breaks are required under the applicable CBA or applicable law) in accordance with company policies and applicable law.";
    static REJECTION_A_TEXT = "I was not provided meal break(s) in accordance with company policies and applicable law.";
    static REJECTION_B_TEXT = "I was not provided rest break(s) in accordance with company policies and applicable law.";
    static REJECTION_C_TEXT = "My timecard does not accurately reflect all of the hours that I worked today.";

    static APPROVED_ATTESTATION_SPANISH_TEXT = "Certifico además que se me dio la oportunidad de tomar todos los descansos para comer y descansar (si se requieren descansos según el CBA o ley applicable) de acuerdo con las pólizas de la empresa y la ley applicable.";
    static REJECTION_A_SPANISH_TEXT = "No me proporcionaron descansos para comer de acuerdo con las pólizas de la empresa y la ley aplicable.";
    static REJECTION_B_SPANISH_TEXT = "No me proporcionaron descansos de acuerdo con las pólizas de la empresa y la ley aplicable.";
    static REJECTION_C_SPANISH_TEXT = "Mi tarjeta de horas no reflecta con precisión todas las horas que trabajé hoy.";
    static SUPERVISOR_OVERRIDE_TEXT = "Supervisor override because employee is not available.";

    static SUPERVISOR_OVERRIDE = "SupervisorOverride";
    static LANGUAGE_SELECTED = "LanguageSelected";
    static OVERRIDE_REASON = "OverrideReason";
    static ATTESTATION_OTHER_REASON = "OtherReason";

    static APPROVED_ATTESTATION = "ApprovedAttestation";
    static REJECTION_A = "RejectionA";
    static REJECTION_B = "RejectionB";
    static REJECTION_C = "RejectionC";
    static DRAWING_SIGNATURE = "DrawingSignature";

    static ATTACHMENT_EMPLOYEE_ATTESTATION_TYPE = "EmployeeSignImage";
    static ATTACHMENT_FOREMAN_ATTESTATION_TYPE = "ForemanSignImage";
    static ATTESTATION_STATUS_OVERRIDE = "Override";
    static ATTESTATION_STATUS_APPROVED = "Approved";
    static ATTESTATION_STATUS_REJECTED = "Rejected";

    static PLEASE_SELECT_ATLEAST_ONE_REJECTION = "Please make an attestation selection to save changes.";
    static PLEASE_SELECT_REJECT_REASON = 'Please select at least one reason why you are attesting "No" to your time.';
    static ATTESTATION_SUPERVISOR_SWITCHING_MESSAGE = "Switching to Supervisor Override will delete the current attesation. Continue?"
    static ATTESTATION_EDIT_CONFIRMATION_MESSAGE = "Modifications to the current form will delete the current attestation. Continue?";
    static ATTESTATION_EMPLOYEE_SWITCHING_MESSAGE = "Switching to Employee will delete the current attesation. Continue?"
    static TIMECARD_ALREADY_ATTESTED_MESSAGE = "Attested timecards cannot be deleted. To delete the timecard, delete the attestation first.";
    static ADD_UPDATE_TIMECARD_ALREADY_ATTESTED_MESSAGE = "The employee has already attested to their time and modifications cannot be made. Corrections may be made by deleting the attestation, and have a new attestation completed.";
    static PLEASE_ENTER_OVERRIDE_REASON = "Please select override reason.";
    static PLEASE_ENTER_SIGNATURE = "Please enter signature.";

    static ATTESTATION_SAVED_SUCCESSFULLY = "Attestation saved successfully";
    static CONFIRMATION_ATTESTATION_DELETED_MESSAGE = "You are about to delete an attestation. Continue?";
    static TIMECARDS_CANNOT_BE_SUBMITTED_SINCE_ATTESTATION_IS_MISSING = "Timecards cannot be submitted since attestation is missing.";
    static ATTESTATION_WARNING_MESSAGE = 'The Employee(s) below have at least one recorded "No" attestation. Please inquire with your team member regarding this attestation.';
    static TIMECARD_ALREADY_ATTESTED_PUNCHES_MESSAGE = "Attested timecard punches cannot be modified.";

    static ATTESTATION_YES = "Y";
    static ATTESTATION_NO = "N";
    static YES_TEXT = "Yes";
    static NO_TEXT = "No";
    static SPANISH_YES_TEXT = "Sí";
    static NOT_APPLICABLE = "N/A";
    static ATTESTATION_LANGUAGE_ENGLISH = "English";
    static ATTESTATION_LANGUAGE_SPANISH = "Spanish";
    static ERROR_HEADER_MESSAGE = "Error";
    static WARNING_HEADER_MESSAGE = "Warning";

    static ATTESTATION_ERROR_MODAL = "AttestationErrorModal";
    static ATTESTATION_SWITCHING_MODAL = "AttestationSwitchingModal";
    static ATTESTATION_CLOSE_WARNING_MODAL = "AttestationCloseWarningModal";
    static ATTESTATION_OPEN_DELETE_MODAL = "AttestationOpenDeleteModal";
    static ATTESTATION_CLOSE_DELETE_MODAL = "AttestationCloseDeleteModal";
    static ATTESTATION_SUBMIT_TIMECARD = "AttestationSubmitTimecard";
    static ATTESTATION_CLOSE_BACK_MODAL = "AttestationCLoseBackModal";
    static ATTESTATION_EDIT_CONFIRMATION_MODAL = "AttestationEditConfirmationModal";

    static ENTER_HOURS_THRESHOLD = 4.5;

    static PNG_BASE64 = "data:image/png;base64,";

    //validations

    static PUNCHES = "punches";
    static DUPLICATE = "duplicate";
    static NOTATTEST = "notAttest";

    static TM_VOUCHER_SIGNATURE_DISCRIMINATOR = "TMVoucherSignature";
    static DELETE_TM_MISCELLANEOUS_HEADER = "Delete Miscellaneous";
    static DELETE_TM_MISCELLANEOUS_MESSAGE = "Are you sure? Do you want to delete miscellaneous?";
    static TM_MATERIAL = "tmMaterials";
    static TM_MISCELLANEOUS = "tmMiscellaneous";
    static TM_MISCELLANEOUS_TYPE = "TMMiscellaneousType";
    static TM_MISCELLANEOUS_DESCRIPTION = "TMMiscellaneousDescription";
    static TM_MISCELLANEOUS_SECTION_HEADER = "Miscellaneous";

    static PNG_IMAGE_FORMAT = 'image/png';
    static ATTACHMENT_RESTRICTION_VALIDATION = 'You can only select up to 10 images at a time';

    static ATTESTATION_HEADER = "Attestation";

    static TOTAL_ATTACHMENT_SIZE_EXCEEDED = "Total attachment size exceeds the 15 MB";
    static MAX_ATTACHMENT_SIZE_MB = 15;
}